export default "__VITE_ASSET__Bjjiouet__"